import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Optional,
  Inject,
  ViewChild,
  signal,
  OnChanges,
} from '@angular/core';
import {
  CheckstatusChangeObj,
  Reason,
  DataIds,
  StatusChangeActivity,
  ISaveStatusChangeActivity,
  UnblockModel,
  LaunchpadModel,
  MailerModel,
  OfferRevokeDetails,
  ISaveCorrespondenceActivity,
} from 'src/app/shared/models/activity-dashboard-model';
import { ActivityService } from 'src/app/core/services/activity.service';
import { FileService } from '../../../core/services/file.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '../../../../../node_modules/@angular/forms';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';

import { AssociateService } from '../../offerdb/services/associate.service';
// import * as _ from 'lodash'
import includes from 'lodash/includes';
import { DatePipe } from '@angular/common';
import jsPDF from 'jspdf';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { map, of, Subject, switchMap } from 'rxjs';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmPopupComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { ViewProfileComponent } from 'src/app/shared/components/view-profile/view-profile.component';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { FaceValidationResponse } from '../../offerdb/models/template';

@Component({
  selector: 'activity-status-change',
  templateUrl: './activity-status-change.component.html',
  styleUrls: ['./activity-status-change.component.scss'],
  standalone: false,
})
export class ActivityStatusChangeComponent implements OnInit, OnChanges {
  updateOffer = {
    dojs: '',
    puIds: '',
    postingLocations: '',
  };

  launchPad = {
    candidate: [
      {
        candidateId: '',
        doj: null,
        offerStatus: '',
        posLoc: '',
        unit: '',
        activityId: null,
      },
    ],
  };

  indentObject = {
    appCode: '',
    aprMail: 0,
    candidateID: '',
    country: '',
    empNo: '',
    ijpflag: 1,
    indentID: '',
    jobLevel: '',
    lastModifiedBy: '',
    pucode: '',
    roleCode: '',
  };

  unBlockIndentObj = {
    appCode: 'InTAP',
    candidateID: '',
    dateofJoining: '',
    empNo: '',
    empSourceCode: 'InTAP',
    indentID: '',
    lastModifiedBy: '',
    stageCode: 'REOPEN',
  };

  blockIndentBpo = {
    rolecapCode: '',
    applicationId: null,
    cityId: null,
    candID: '',
    doj: '',
    indentID: null,
    lastModifiedBy: '',
    recruiterID: '',
    stptype: 'string',
  };
  openIndentBpo = {
    rolecapCode: '',
    applicationId: null,
    cityId: null,
    candID: '',
    indentID: null,
    userEmpNo: '',
    lastModifiedBy: '',
  };
  templateObj: any = [
    {
      jl: '',
      activityId: '',
      companyHiringTypeId: '',
      stream: null,
      unitCode: null,
    },
  ];
  private _successER = new Subject<string>();

  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  companyHiringType: any; //= 1;

  public isCollapsed: boolean = false;
  //time
  public timeModifiedOn: string;

  @Input() checkStatusChangeObj: CheckstatusChangeObj;
  @Input() coupledcheckStatusChangeObj: CheckstatusChangeObj;
  @ViewChild('sfoContent') sfoContent: any;

  value: boolean;
  val: boolean;
  ids: DataIds;
  remarksField: string;
  reasonDescription: any;
  deleteMsg: string;
  reason: string;
  reasonobj: Reason;
  stpAddress;
  stpAddress2;
  establishment;
  candidateOfferDetail;
  changedDoj: boolean = false;
  addressString = '';
  reasonvalue: any;
  attachmentId: any;
  modalOption: NgbModalOptions = {};

  isDeleteDisable: boolean = true;
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  @Input() candidateObj: any;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Input() candidateDetail: any[];
  @Input() noOfTimes: number;
  @Input() minDate = new Date();
  @Input() candidateActivities: any[];

  reasondesc: string;
  editactivity: any = false;
  reasonid: number;
  reasonCtrl = new FormControl();
  userloggedin: any;
  loginUserName: any;

  @Output() singleformValid: EventEmitter<boolean> = new EventEmitter();
  @Output() createdOnValue: EventEmitter<any> = new EventEmitter();
  @Output() createdOnValue1: EventEmitter<any> = new EventEmitter();
  @Output() displayReason: EventEmitter<boolean> = new EventEmitter();
  @Output() reasonlist: EventEmitter<any> = new EventEmitter();
  @Output() activityId: EventEmitter<any> = new EventEmitter();

  executeStatusChngAct: boolean = true;
  activitiesExecuted: any;
  sezAddress: any[];
  chkDoj: any;
  location: any;
  chkLoc: any;
  jl: string;
  textArray: any[];
  mailSubject: any;
  mailBody: any;
  fullAddress: any[];
  attachmentName: any;
  empEmail: any;
  canEmail: any;
  candAdress: any;
  clauses;
  remarksMandatory: boolean = true;
  flagData: any = null;
  errorCode: any;
  sfoMssg: any;
  bcgStatus: any;
  offerRejectCheck: boolean = false;
  disableOfferSendBtn: boolean = false;
  hrChecklist: any;
  expandedEvent: any;
  selectedIndexQ = 0;
  unavailableDate: Date;
  isSkipHRCheck: boolean = false;
  skipHRFileExist: boolean = false;
  approverIds = [1372987, 370188];
  offerInvalidRejectCheck: boolean = false;
  allOfferTypes = signal<string[]>([]);
  selectedOfferType = signal<string>('');
  //@Input() dialogRef: MatDialogRef<ActivityDialogComponent>;
  constructor(
    private date: DatePipe,
    private activityService: ActivityService,
    private fileService: FileService,
    private profileService: ProfileService,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
    public confirmDialog: MatDialog,
    private modalService: NgbModal,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private associateService: AssociateService,
  ) {
    if (data) {
      this.checkStatusChangeObj = data.checkStatusChangeObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
      this.candidateApplicationIds = data.editcandidateApplicationIds;
      // this.candidateId = data.candidateId
    }
  }

  rejectionReasons: any;
  excludedReasonIds = [543, 120, 98, 687, 90, 110, 141, 106];
  selectedValue: string;
  selectedValue2: string;
  toField: any;
  notes: string;
  reasonId: any;
  saveMsg: string;
  notes2: string;
  reasonId2: any;
  toggleBtn: boolean = false;
  doj: any;
  changedLoc: boolean = false;
  templateRecieved: boolean = false;

  resObj: any;
  empAttributes: any;
  empNo: any;
  SFOData: any;
  disableSFO: boolean;
  disableSubmit: boolean;
  recallActivity: boolean;
  compHiringTypeID = +localStorage.getItem('fresherCompHiringTypeId');
  screenDesc: string;
  cityId: any; //@Input() dialogRef: MatDialogRef<ActivityDialogComponent>;
  typeFlag: string;
  isMapFile = false;
  hrApplicationForm: any;
  hrExpEHC: any;
  hrChecklistNotes: any;
  candidateId: any;
  isExceptionUserLogin: boolean = false;
  faceValidationData = signal<FaceValidationResponse>(null);
  enableSendButton = signal(false);
  veriFace = signal(false);

  ngOnInit() {
    // let loggedinUser = JSON.parse(localStorage.getItem("loggedInUser"));
    this.veriFace.set(JSON.parse((window as any).env.veriFace));

    this.empAttributes = JSON.parse(localStorage.getItem('loggedInUser'));

    this.empEmail = this.empAttributes.email;
    this.empNo = this.empAttributes.attributes.EmpNo[0];
    if (this.approverIds.includes(+this.empNo)) {
      this.isExceptionUserLogin = true;
    }

    //this.getActivity();
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
    if (this.companyHiringType == '4' && this.checkStatusChangeObj.activityId == 600311 && this.veriFace()) {
      this.faceValidation();
    }
    this.isMapFile =
      (this.companyHiringType == '1' || this.companyHiringType == '4' || this.companyHiringType == '9') &&
      this.checkStatusChangeObj.activityId == 600301
        ? true
        : this.companyHiringType == '1' &&
            (this.checkStatusChangeObj.activityId == 500317 || this.checkStatusChangeObj.activityId == 500308)
          ? true
          : false;
    this.activityService.getCandidateOfferUpdate(this.checkStatusChangeObj.applicationId).subscribe((dataFetched) => {
      this.resObj = dataFetched;
      const date = new DatePipe('en-US').transform(this.resObj.joining_date, 'dd-MMM-yyyy');
      this.doj = new Date(date);
      this.canEmail = this.resObj.candidateEmail;
      console.log(this.canEmail, 'candmail');

      this.chkDoj = this.doj;
      this.chkLoc = this.location;
      this.location = this.resObj.location;
      this.establishment = this.resObj.establishment_type;
      this.activityService.getCityId(this.candidateApplicationIds[0], this.resObj.location).subscribe((data1) => {
        this.cityId = data1;
      });
      const cid = this.resObj.candidate_id.toString();
      this.associateService.getActivitiesOnCandidate(this.candidateApplicationIds[0], cid).subscribe((a) => {
        this.activitiesExecuted = a.activityModel;
        this.candAdress = a.address;
      });
    });

    //offerAcceptCheck for offer accept by recruiter after offer rejected by IL candidate
    if (this.companyHiringType == '1' && this.checkStatusChangeObj.activityId == 600304) {
      this.activityService.getOfferAcceptCheck(this.checkStatusChangeObj.applicationId).subscribe(
        (offerAcceptRes) => {
          this.offerRejectCheck =
            offerAcceptRes.isOfferValid === 'Y' && offerAcceptRes.isOfferRejected === 'Y' ? true : false;
          this.offerInvalidRejectCheck =
            offerAcceptRes.isOfferValid === 'N' && offerAcceptRes.isOfferRejected === 'Y' ? true : false;
          if (this.offerRejectCheck || this.offerInvalidRejectCheck) {
            this.isMapFile = true;
            this.disableOfferSendBtn = true;
            const data = {
              msg: offerAcceptRes.message,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack', 10000);
          } else {
            this.isMapFile = false;
            this.disableOfferSendBtn = false;
          }
        },
        (_err) => {
          const data = {
            msg: 'Something went wrong! Please try again!',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
          this.isMapFile = false;
          this.disableOfferSendBtn = false;
        },
      );
    }

    console.log('coupled paasas', this.coupledcheckStatusChangeObj);

    console.log('this.check statiyst obj', this.checkStatusChangeObj);
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);

    // this.editId = { objectId: this.checkStatusChangeObj.applicationId, objectType: 'AP' };
    console.log('in ngOninit', this.notes);
    let activityId;
    if (this.checkStatusChangeObj !== undefined) {
      activityId = this.checkStatusChangeObj.activityId;
      console.log('activity id in status cham--', activityId);
    }

    if (this.checkStatusChangeObj == undefined) {
      activityId = this.coupledcheckStatusChangeObj.activityId;
    }

    if (activityId && activityId != 500317) {
      this.activityService.getActivityReasons(activityId).subscribe((data) => {
        // console.log(data);
        let sortedEntries = Object.entries(data).sort((a: any, b: any) => {
          return a[1].localeCompare(b[1]);
        });
        if (activityId == 500302 && this.companyHiringType == 1) {
          sortedEntries = Object.entries(data).sort((a, b) => {
            const orderValue = (val) => {
              if (val === 'HR Round') {
                return 1;
              }
              if (val === 'No show') {
                return 2;
              }
              return 0;
            };

            return orderValue(a[1]) - orderValue(b[1]);
          });
        }
        this.rejectionReasons = sortedEntries;
        if (this.noOfTimes >= 0 && this.companyHiringType == 1) {
          this.reasonId = this.rejectionReasons?.[this.noOfTimes]?.[0];
          if (this.noOfTimes == this.rejectionReasons.length - 1 && activityId != 500302) {
            const dialogData = new ConfirmDialogModel(
              '',
              'You have reached the maximum limit. After that you will not be able to execute this activity.',
            );
            this.confirmDialog.open(ConfirmPopupComponent, {
              maxWidth: '500px',
              data: dialogData,
              disableClose: true,
            });
          }
        }
      });
    }

    // this.activityService.getReasons().subscribe(data => {
    //   this.rejectionReasons = data;
    // })
    if (this.editactivity) {
      this.editId = {
        objectId: this.checkStatusChangeObj.applicationId,
        objectType: 'AP',
        activityId: this.checkStatusChangeObj.activityId,
      };
      console.log(this.checkStatusChangeObj);
      this.getActivity(this.checkStatusChangeObj);
      this.isCollapsed = false;
      if (this.checkStatusChangeObj.activityId == 500317) {
        this.hrApplicationForm = true;
        this.hrExpEHC = true;
      }
    }

    this.showMoreLess();
    if (
      this.candidateObj &&
      this.checkStatusChangeObj.activityId == 600301 &&
      this.companyHiringType != 4 &&
      this.companyHiringType != 2
    ) {
      this.disableSFO = true;
      this.activityService
        .getSFO(this.candidateObj[0].candidateId, this.companyHiringType, this.candidateObj[0].applicationId)
        .subscribe((sfodata) => {
          console.log('sfo data', sfodata);
          this.SFOData = sfodata;
          if (this.SFOData != 'Success') {
            this.disableSFO = true;
            const data = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          } else {
            if (this.companyHiringType == 9) {
              this.callCheckBpm();
            } else if (['1', '6'].includes(this.companyHiringType)) {
              this.sfoMssg = null;
              let _SkipSFOActiveFlag: string | undefined;
              if (this.candidateDetail[0].sourceId == 11 || this.candidateDetail[0].sourceId == 16) {
                const hrMessageDialog = new ConfirmDialogModel('Warning!', 'Do you want to skip panel validation?');
                const dialogRefPanel = this.confirmDialog.open(ConfirmDialogComponent, {
                  maxWidth: '400px',
                  data: hrMessageDialog,
                });
                dialogRefPanel.afterClosed().subscribe((result) => {
                  if (result) {
                    this.panelCheck('Y');
                  } else if (result == false) {
                    this.panelCheck('N');
                  }
                });
              } else {
                _SkipSFOActiveFlag = 'N';
                this.panelCheck();
              }
            } else {
              this.disableSFO = false;
            }
          }
        });
    }
    if (this.candidateObj && this.checkStatusChangeObj.activityId == 600301 && this.companyHiringType == 4) {
      this.disableSFO = true;
      this.callCheckBpm();
    }

    if (this.candidateObj && this.checkStatusChangeObj.activityId == 500308) {
      this.panelCheck();
    }

    if (this.checkStatusChangeObj.activityId == 600306) {
      this.recallActivity = true;
    }
    if (this.compHiringTypeID == 1) {
      this.screenDesc = 'Lateral';
    }
    if (this.compHiringTypeID != 1) {
      if (this.compHiringTypeID == 2) {
        this.screenDesc = 'Fresher';
      } else {
        this.screenDesc = 'BPM';
      }
    }

    if (this.checkStatusChangeObj.activityId == 500312 && this.companyHiringType == 1) {
      this.activityService
        .getBcgStatus(
          this.checkStatusChangeObj.applicationId,
          this.checkStatusChangeObj.activityId,
          this.companyHiringType,
        )
        .subscribe((response) => {
          this.bcgStatus = response;
        });
    }

    if (this.checkStatusChangeObj.activityId == 500317) {
      this.disableSubmit = true;
      this.activityService.getAllOfferTypes().subscribe(
        (offerTypes) => {
          this.allOfferTypes.set(offerTypes);
        },
        (err) => {
          console.error('Error fetching offer types', err);
        },
      );
      const _hrActivityExecuted = this.candidateActivities.some((act) => act.activityid === 500317);
      // if(hrActivityExecuted){
      //   const hrExecutedDialog = new ConfirmDialogModel('', 'HR checklist activity can not be executed more than one time');
      //   this.confirmDialog.open(ConfirmPopupComponent, { maxWidth: "400px", data: hrExecutedDialog, disableClose: true });
      //   return ;
      // }
      const applnId = this.candidateObj ? this.candidateObj[0].applicationId : this.candidateApplicationIds[0];
      this.activityService.getHRchecklist(applnId).subscribe(
        (res) => {
          this.hrChecklist = res.hrQuestions;
          this.errorCode = res.errorCode;
          const message = res.message;
          this.expandedEvent = this.hrChecklist[0].sectionName;
          const sourceId = this.candidateDetail[0].sourceId;
          if (['11', '16'].includes(sourceId) || res.isCampusSource == 'Y') {
            let PanelMessageDialog: any = '';
            if (['11', '16'].includes(sourceId)) {
              PanelMessageDialog = new ConfirmDialogModel(
                'Warning!',
                'The HR Checklist is optional for this application from Subsidary Movement, or Subcon Conversion. Do you still want to continue?',
              );
            } else {
              PanelMessageDialog = new ConfirmDialogModel('Warning!', res.hrSourceResponse);
            }
            const dialogRefSource = this.confirmDialog.open(ConfirmDialogComponent, {
              maxWidth: '400px',
              data: PanelMessageDialog,
            });
            dialogRefSource.afterClosed().subscribe((dialogResultApprove) => {
              if (dialogResultApprove) {
                if (res.errorCode == 0) {
                  this.disableSubmit = false;
                } else if (res.errorCode == 1 || res.errorCode == 2) {
                  this.disableSubmit = true;
                  if (!this.editactivity) {
                    const hrMessageDialog = new ConfirmDialogModel('Warning!', message);
                    this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: hrMessageDialog });
                  }
                }
              } else if (dialogResultApprove == false) {
                this.reasonId = 20;
                this.send1();
              }
            });
          } else {
            if (res.errorCode == 0) {
              this.disableSubmit = false;
            } else if (res.errorCode == 1 || res.errorCode == 2) {
              this.disableSubmit = true;
              if (!this.editactivity) {
                const hrMessageDialog = new ConfirmDialogModel('Warning!', message);
                this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: hrMessageDialog });
              }
            }
          }
          // if(res.hrSourceResponse && !this.editactivity){
          //   const dialogMsg = new ConfirmDialogModel('', res.hrSourceResponse);
          //   this.confirmDialog.open(ConfirmPopupComponent, { maxWidth: "400px", data: dialogMsg, disableClose: true });
          // }
        },
        (_err) => {
          const data = {
            msg: 'Something went wrong! Please try again!',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        },
      );
      if (this.isMapFile) {
        this.fileService.saveAttachmentMultiple(
          this.checkStatusChangeObj.applicationId,
          this.companyHiringType,
          this.fileData,
          this.deletedFile,
          this.checkStatusChangeObj.activityId,
        );
      } else {
        this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
      }
    }
  }
  panelCheck(skipSfo?: string) {
    this.disableSFO = true;
    this.activityService.getFlag(this.candidateObj[0].applicationId, skipSfo).subscribe(
      (flagData) => {
        if (flagData.flag == 'N') {
          this.disableSFO = true;
          this.flagData = flagData.flag;
          console.log(this.flagData, '...............');
          this.sfoMssg = flagData.message;
          this.openModalSfo();
          // let data = {
          //   msg: flagData.message,
          //   isSuccess: false,
          // };
          // this.activityService.openSnackBar(data, 'danger-snack');
        } else if (flagData.flag == 'Y') {
          this.flagData = flagData.flag;
          this.disableSFO = false;
        } else if (flagData.flag == 'R') {
          this.flagData = flagData.flag;
          this.disableSFO = true;
          const data = {
            msg: flagData.message,
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        } else if (['Q', 'NOBA', 'M', 'T'].includes(flagData.flag)) {
          this.disableSFO = true;
          this.flagData = flagData.flag;
          this.sfoMssg = flagData.message;
          console.log(this.sfoMssg);
          this.openModalSfo();
        } else if (flagData.flag == 'UMR') {
          const messageReject = flagData.message;
          const dialogData = new ConfirmDialogModel('Please confirm:', messageReject);
          const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '500px', data: dialogData });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.flagData = 'Y';
              this.disableSFO = false;
            } else {
              this.flagData = 'R';
              this.disableSFO = true;
            }
          });
        } else if (flagData.flag == 'YES') {
          this.disableSFO = false;
          this.flagData = flagData.flag;
          this.sfoMssg = flagData.message;
          console.log(this.sfoMssg);
          this.openModalSfo();
        } else if (flagData.flag == 'SKIPSFO') {
          this.disableSFO = false;
          this.flagData = flagData.flag;
          this.sfoMssg = flagData.message;
          console.log(this.sfoMssg);
          this.openModalSfo();
        }
        if (this.isExceptionUserLogin) {
          this.disableSFO = false;
        }
      },
      (_err) => {
        this.flagData = 'R';
        const data = {
          msg: 'Panelist validation is not working, please try again !!',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );
  }
  faceValidation() {
    this.ngxLoader.start();
    this.activityService.getFaceValidationData(this.checkStatusChangeObj.applicationId).subscribe(
      (data) => {
        this.ngxLoader.stop();
        if (data) {
          this.faceValidationData.set(data);
        }
      },
      (_err) => {
        this.ngxLoader.stop();
      },
    );
  }
  checkFaceValidationSendButton() {
    const status = this.faceValidationData()?.status;
    if (this.veriFace()) {
      if (status === 'Failed') {
        if (this.reasonId && this.rejectionReasons) {
          const selectedReason = this.rejectionReasons.find((r) => r[0] === this.reasonId);
          if (selectedReason && selectedReason[1]?.toLowerCase().includes('exception')) {
            this.enableSendButton.set(false);
          } else {
            this.enableSendButton.set(true);
          }
        } else {
          this.enableSendButton.set(true);
        }
      } else if (status === 'Success') {
        if (this.reasonId && this.rejectionReasons) {
          const selectedReason = this.rejectionReasons.find((r) => r[0] === this.reasonId);
          if (selectedReason && selectedReason[1]?.toLowerCase().includes('exception')) {
            this.enableSendButton.set(true);
          } else {
            this.enableSendButton.set(false);
          }
        } else {
          this.enableSendButton.set(false);
        }
      }
    }
  }
  getResultEntries() {
    const results = this.faceValidationData()?.results;
    return Object.entries(results || {});
  }
  // restrictSfo(){
  //   if (this.candidateObj && this.checkStatusChangeObj.activityId == 600301 && this.companyHiringType != 4) {
  //     this.activityService.getSFO(this.candidateObj[0].candidateId, this.companyHiringType, this.candidateObj[0].applicationId).subscribe(sfodata => {
  //       console.log("sfo data", sfodata)
  //       this.SFOData = sfodata
  //       if (this.SFOData != "Success") {
  //         this.disableSFO = true;
  //         let data = {
  //           msg: sfodata,
  //           isSuccess: false,
  //         };
  //         this.activityService.openSnackBar(data, 'danger-snack');
  //       }else{
  //         if(this.companyHiringType == 1){
  //           this.sfoMssg = null;
  //           this.activityService.getFlag(this.candidateObj[0].applicationId).subscribe(flagData=>{
  //             if(flagData.flag == 'N'){
  //               this.disableSFO = true;
  //               this.flagData = flagData.flag
  //               console.log(this.flagData, "...............");
  //               this.sfoMssg = flagData.message;
  //               this.openModalSfo();
  //               // let data = {
  //               //   msg: flagData.message,
  //               //   isSuccess: false,
  //               // };
  //               // this.activityService.openSnackBar(data, 'danger-snack');
  //             }else if(flagData.flag == 'Y'){
  //               this.flagData = flagData.flag
  //             }else if(flagData.flag == 'R'){
  //               this.flagData = flagData.flag
  //               this.disableSFO = true;
  //               let data = {
  //                 msg: flagData.message,
  //                 isSuccess: false,
  //               };
  //               this.activityService.openSnackBar(data, 'danger-snack');
  //             }

  //           },(err)=>{
  //               this.flagData = 'R';
  //               let data = {
  //                 msg: "Panelist validation is not working, please try again !!",
  //                 isSuccess: false,
  //               };
  //               this.activityService.openSnackBar(data, 'danger-snack');

  //             });
  //           }
  //         }
  //       });
  //   }
  // }

  createLaunchPadObject() {
    const date = new Date(this.resObj.joining_date);
    const offset = date.getTimezoneOffset();
    if (offset < 0) {
      date.setHours(12, 0, 0);
    }
    this.launchPad.candidate[0].candidateId = this.candidateObj[0].candidateId;
    this.launchPad.candidate[0].doj = date;
    this.launchPad.candidate[0].posLoc = this.resObj.location;
    this.launchPad.candidate[0].unit = this.resObj.puCode;
    this.launchPad.candidate[0].activityId = this.checkStatusChangeObj.activityId;
    console.log('launchpad', this.launchPad);
  }

  blockIndentIL() {
    this.indentObject.appCode = 'InTAP';
    this.indentObject.aprMail = 0;
    this.indentObject.candidateID = this.resObj.candidate_id;
    this.indentObject.country = this.resObj.countryCode;
    this.indentObject.empNo = this.empNo;
    this.indentObject.ijpflag = 0;
    this.indentObject.indentID = this.resObj.indentId;
    this.indentObject.jobLevel = this.resObj.jobLevel;
    this.indentObject.lastModifiedBy = this.resObj.lastModifiedBy;
    this.indentObject.pucode = this.resObj.puCode;
    this.indentObject.roleCode = this.resObj.roleCode;
    console.log('ONDENT OBJECT', this.indentObject);
  }
  unblockIndentObjIL() {
    this.unBlockIndentObj.appCode = 'InTAP';
    this.unBlockIndentObj.candidateID = this.resObj.candidate_id;
    this.unBlockIndentObj.dateofJoining = this.resObj.joining_date;
    this.unBlockIndentObj.empNo = this.empNo;
    this.unBlockIndentObj.empSourceCode = 'InTAP';
    this.unBlockIndentObj.indentID = this.resObj.indentId;
    this.unBlockIndentObj.lastModifiedBy = this.resObj.lastModifiedBy;
    this.unBlockIndentObj.stageCode = 'REOPEN';
    console.log('unblockindent data', this.unBlockIndentObj);
  }
  updateOfferData() {
    this.updateOffer.dojs = this.resObj.dojs;
    this.updateOffer.postingLocations = this.resObj.postingLocations;
    this.updateOffer.puIds = this.resObj.puIds;
    console.log('update Offer detail', this.updateOffer);
  }
  blockIndentBpm() {
    this.blockIndentBpo.rolecapCode = this.resObj.roleCapCode;
    this.blockIndentBpo.applicationId = this.candidateApplicationIds[0];
    this.blockIndentBpo.cityId = this.cityId[0].key;
    this.blockIndentBpo.candID = this.resObj.candidate_id;
    this.blockIndentBpo.doj = this.date.transform(this.resObj.joining_date, 'dd MMM yyyy').toString();
    this.blockIndentBpo.indentID = this.resObj.indentId;
    this.blockIndentBpo.lastModifiedBy = this.resObj.lastModifiedBy;
    this.blockIndentBpo.recruiterID = this.empNo;
    this.blockIndentBpo.stptype = this.resObj.establishment_type;
  }
  openIndentBpm() {
    this.openIndentBpo.rolecapCode = this.resObj.roleCapCode;
    this.openIndentBpo.applicationId = this.candidateApplicationIds[0];
    this.openIndentBpo.cityId = this.cityId[0].key.toString();
    this.openIndentBpo.candID = this.resObj.candidate_id.toString();
    this.openIndentBpo.indentID = this.resObj.indentId;
    this.openIndentBpo.userEmpNo = this.empNo;
    this.openIndentBpo.lastModifiedBy = this.resObj.lastModifiedBy;
  }
  checkForLateralBpm() {
    if (this.screenDesc == 'Lateral') {
      this.blockIndentIL();
      this.unblockIndentObjIL();
    }
    if (this.screenDesc == 'BPM') {
      this.blockIndentBpm();
      this.openIndentBpm();
    }
    this.createLaunchPadObject();
  }

  testformValid(flag) {
    // console.log('single form working', flag);

    this.singleformValid.emit(flag);
  }

  ngOnChanges() {
    console.log('in ngonchanges');
    this.reasonId = null;
    this.notes = '';
  }
  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }
  send1() {
    this.ids = this.activityService.getDataIds();
    if (this.editactivity) {
      const obj: StatusChangeActivity = {
        applicationIds: this.checkStatusChangeObj.applicationId,
        processID: this.checkStatusChangeObj.processId,
        activityID: this.checkStatusChangeObj.activityId,
        statusId: this.checkStatusChangeObj.statusId,
        reasonId: Number(this.reasonId),
        notes: this.notes,
        createdOn: this.checkStatusChangeObj.createdOn,
        createdBy: this.checkStatusChangeObj.createdBy,
      };
      this.editStatusChangeActivity(obj);
    } else {
      let objS: ISaveStatusChangeActivity;
      console.log('checkstatustobhj', this.checkStatusChangeObj);
      console.log('couplde', this.coupledcheckStatusChangeObj);
      if (this.checkStatusChangeObj !== undefined) {
        console.log('inside check statuts');
        objS = {
          applicationIds: this.candidateApplicationIds,
          processID: this.checkStatusChangeObj.processId,
          activityID: this.checkStatusChangeObj.activityId,
          statusId: this.checkStatusChangeObj.statusId,
          reasonId: Number(this.reasonId),
          notes: this.notes,
          ...(this.isInterviewDateRequired && {
            unavailableDate: this.date.transform(this.unavailableDate, 'dd-MMM-yyyy'),
          }),
        };
      }
      console.log(this.checkStatusChangeObj.statusChangeActivity);
      this.saveStatusChangeActivity(objS);
    }
    this.showMoreLess();
  }
  openModalSfo() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalService.open(this.sfoContent, this.modalOption);
  }

  send() {
    if (
      this.checkStatusChangeObj.activityId == 600311 &&
      this.companyHiringType == 4 &&
      this.faceValidationData()?.status === 'Failed' &&
      (!this.fileData || this.fileData.length === 0)
    ) {
      const data = {
        msg: 'Attachment is mandatory when Face Validation status is Failed',
        isSuccess: false,
      };
      this.activityService.openSnackBar(data, 'danger-snack');
      return;
    }
    if (this.checkStatusChangeObj.activityId == 600307) {
      this.reasonvalue = this.rejectionReasons.filter((ele) => {
        return ele.indexOf(this.reasonId.toString()) != -1;
      })[0][1];
      if (this.isMapFile) {
        this.fileService.saveAttachmentMultiple(
          this.checkStatusChangeObj.applicationId,
          this.companyHiringType,
          this.fileData,
          this.deletedFile,
          this.checkStatusChangeObj.activityId,
        );
      } else {
        this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
      }
      this.createMailerObj();
    } else {
      const validFlags = ['N', 'Q', 'CBI', 'NCBI', 'NOBA', 'M', 'T', 'SKIPSFO'];
      if (this.checkStatusChangeObj.activityId == 600301 && validFlags.includes(this.flagData)) {
        const messageReject = this.sfoMssg.split('Upload')[0] + ' ' + 'Do you still want to continue?';
        const dialogData = new ConfirmDialogModel('Please confirm:', messageReject);
        const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '500px', data: dialogData });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.CheckEhc();
          }
          // if (!this.ifCoupled) {
          //   this.refreshcandiates.emit("true");
          // }
        });
      } else if (this.checkStatusChangeObj.activityId != 600301) {
        this.send1();
      } else if (
        this.checkStatusChangeObj.activityId == 600301 &&
        ([null, 'Y', 'YES'].includes(this.flagData) || this.isExceptionUserLogin)
      ) {
        this.CheckEhc();
      }
    }
    //   }
    //   console.log(this.checkStatusChangeObj.statusChangeActivity);
    //   this.saveStatusChangeActivity(objS);
    // }
    // this.showMoreLess();
    // if(!this.ifCoupled)
    // {
    //   this.refreshcandiates.emit("true");
    // }
  }
  selectedActivity() {
    const listActivities = [600101, 600102, 600103, 600303, 600304, 600305];
    if (
      this.activityService.lastActivityPerformed &&
      this.activityService.lastActivityPerformed.activityid &&
      listActivities.includes(this.activityService.lastActivityPerformed.activityid) &&
      localStorage.getItem('role') === 'Recruiter' &&
      localStorage.getItem('fresherCompHiringTypeId') === '4' &&
      this.checkStatusChangeObj.activityId == 200304
    ) {
      return true;
    } else {
      return false;
    }
  }

  saveCoupledActivity(coupledcheckStatusChangeObj) {
    let objS: ISaveStatusChangeActivity;
    console.log('reason id 2', this.reasonId2);
    if (coupledcheckStatusChangeObj !== undefined) {
      console.log('inside couplde check statuts');
      objS = {
        applicationIds: this.candidateApplicationIds,
        processID: coupledcheckStatusChangeObj.processId,
        activityID: coupledcheckStatusChangeObj.activityId,
        statusId: coupledcheckStatusChangeObj.statusId,
        reasonId: Number(this.reasonId2),
        notes: this.selectedValue2,
      };
    }
    console.log(this.checkStatusChangeObj.statusChangeActivity);
    this.saveStatusChangeActivity(objS);
  }
  async saveStatusChangeActivity(obj: ISaveStatusChangeActivity) {
    console.log('inside save');

    console.log(obj);
    if (this.reasonId != null) {
      console.log('inside if');

      //.

      switch (this.checkStatusChangeObj.activityId as any) {
        case '600304':
          this.typeFlag = 'A';
          this.launchPad.candidate[0].offerStatus = 'Offer Accepted';
          this.checkForLateralBpm();
          // this.offerAcceptReject()
          break;
        case '600305':
          this.typeFlag = 'R';
          this.launchPad.candidate[0].offerStatus = 'Offer Rejected';
          this.checkForLateralBpm();
          this.offerAcceptReject();
          break;

        case '600306':
          if (this.checkStatusChangeObj.activityId == 600306) {
            this.activityService.recallOffer(this.candidateObj[0].applicationId).subscribe(
              (recall: any) => {
                const data = {
                  msg: recall.message,
                  isSuccess: recall.flag,
                };
                if (data.isSuccess == true) {
                  this.activityService.openSnackBar(data, 'success-snack');
                  this.statusChangeForRecall(obj);
                } else {
                  this.activityService.openSnackBar(data, 'danger-snack');
                }
              },
              (err) => {
                const data = {
                  msg: err,
                  isSuccess: false,
                };
                this.activityService.openSnackBar(data, 'danger-snack');
              },
            );
          }

          break;

        case '600308':
          this.typeFlag = 'Recall';
          if (this.checkStatusChangeObj.activityId == 600308) {
            this.activityService.offerRecallApprover(this.candidateObj[0].applicationId).subscribe(
              (response) => {
                const data = {
                  msg: response.message,
                  isSuccess: response.flag,
                };
                if (data.isSuccess == true) {
                  this.activityService.openSnackBar(data, 'success-snack');
                  this.statusChangeForRecall(obj);
                } else {
                  this.activityService.openSnackBar(data, 'danger-snack');
                }
              },
              (err) => {
                const data = {
                  msg: err.error,
                  isSuccess: false,
                };
                this.activityService.openSnackBar(data, 'danger-snack');
              },
            );
          }
          break;

        // if(this.checkStatusChangeObj.activityId==600301 && this.SFOData=="Success"){
        //      console.log("EnTRYonly for SFO")
        //     this.activityService.saveStatusChangeActivity(obj).subscribe((res: any) => {
        //       console.log(res);
        //       console.log("calling get statuschange activity check updated notes");
        //       this.value = true;
        //       this.refreshcandiates.emit("true");
        //       //this.getActivity();
        //       this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);

        //       let data = {
        //         msg: "Saved Successfully",
        //         isSuccess: true
        //       }
        //       this.activityService.openSnackBar(data, 'success-snack');

        //     },
        //       err => {
        //         let data = {
        //           msg: "Some error occurred",
        //           isSuccess: false
        //         }
        //         this.activityService.openSnackBar(data, 'danger-snack');
        //       });
        //   }
        // else if(this.checkStatusChangeObj.activityId != 600301){
        //  alert("Inside")
        // console.log("EnTRYonly for others")
        // if (this.checkStatusChangeObj.activityId != 600306 && this.checkStatusChangeObj.activityId != 600308) {
        //   this.activityService.saveStatusChangeActivity(obj).subscribe((res: any) => {
        //     console.log(res);
        //     console.log("calling get statuschange activity check updated notes");
        //     if (res.error === "failure") {
        //       let data = {
        //         msg: res.message,
        //         isSuccess: false

        //       }

        //       console.log(data);
        //       this.activityService.openSnackBar(data, 'danger-snack');
        //     } else {
        //       this.value = true;
        //       // this.refreshcandiates.emit("true");
        //       if (this.ifCoupled) {
        //         this.createdOnValue.emit(res.createdOn);
        //       }

        //       //this.getActivity();
        //       this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
        //       let data = {
        //         msg: res.message,
        //         isSuccess: true
        //       }
        //       this.activityService.openSnackBar(data, 'success-snack');
        //     }
        //   },
        //     err => {
        //       let data = {
        //         msg: "Some error occurred",
        //         isSuccess: false
        //       }
        //       this.activityService.openSnackBar(data, 'danger-snack');
        //     });
        // }

        // break;

        // case '600308':
        //   this.typeFlag = "Recall"
        //   this.activityService.offerRecallApprover(this.candidateObj[0].applicationId).subscribe(recallApprover =>{
        //     let data = {
        //       msg: recallApprover,
        //       isSuccess: true
        //     }
        //       this.activityService.openSnackBar(data, 'success-snack');
        //       this.statusChangeForRecall(obj)
        //     },
        //   err => {
        //     let data = {
        //       msg: err,
        //       isSuccess: false
        //     }
        //     this.activityService.openSnackBar(data, 'danger-snack');
        //   });

        //   break
      }
    }

    // if(this.checkStatusChangeObj.activityId==600301 && this.SFOData=="Success"){
    //      console.log("EnTRYonly for SFO")
    //     this.activityService.saveStatusChangeActivity(obj).subscribe((res: any) => {
    //       console.log(res);
    //       console.log("calling get statuschange activity check updated notes");
    //       this.value = true;
    //       this.refreshcandiates.emit("true");
    //       //this.getActivity();
    //       this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);

    //       let data = {
    //         msg: "Saved Successfully",
    //         isSuccess: true
    //       }
    //       this.activityService.openSnackBar(data, 'success-snack');

    //     },
    //       err => {
    //         let data = {
    //           msg: "Some error occurred",
    //           isSuccess: false
    //         }
    //         this.activityService.openSnackBar(data, 'danger-snack');
    //       });
    //   }
    // else if(this.checkStatusChangeObj.activityId != 600301){
    //  alert("Inside")
    // console.log("EnTRYonly for others")
    if (this.checkStatusChangeObj.activityId != 600306 && this.checkStatusChangeObj.activityId != 600308) {
      await this.activityService
        .saveStatusChangeActivity(obj)
        .pipe(
          switchMap((resp1: any) => {
            if (this.checkStatusChangeObj.activityId == 600305) {
              return this.activityService.updateLaunchPad(this.launchPad).pipe(map(() => resp1));
            } else {
              return of(resp1);
            }
          }),
        )
        .subscribe(
          (res: any) => {
            if (this.checkStatusChangeObj.activityId == 600304) {
              this.offerAcceptReject();
            }

            console.log(res);
            console.log('calling get statuschange activity check updated notes');
            if (res?.error && (res?.error?.toLowerCase() === 'failure' || res?.error?.toLowerCase() === 'failed')) {
              const data = {
                msg: res.message,
                isSuccess: false,
              };

              console.log(data);
              this.activityService.openSnackBar(data, 'danger-snack');
            } else if (res?.error?.toLowerCase() === 'raul' && this.checkStatusChangeObj.activityId == 500307) {
              this.createdOnValue.emit(res.error);
              const dataRAUL = {
                msg: res.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(dataRAUL, 'success-snack');
            } else {
              this.value = true;
              // this.refreshcandiates.emit("true");
              // res.message="not"
              if (
                this.companyHiringType == 1 &&
                (this.checkStatusChangeObj.activityId == 600304 ||
                  this.checkStatusChangeObj.activityId == 600305 ||
                  this.checkStatusChangeObj.activityId == 200304) &&
                this.resObj.flag == 'S' &&
                res.message.toLowerCase() == 'saved successfully'
              ) {
                const data = {
                  candidateId: this.resObj.candidate_id,
                  appId: this.checkStatusChangeObj.applicationId,
                };
                this.activityService.update_S2rlStatus(data).subscribe((res) => {
                  console.log(res);
                });
              }
              if (res.message.toLowerCase() == 'saved successfully') {
                if (this.compHiringTypeID == 1) {
                  this.activityService
                    .s2hStatusUpdate(this.resObj.candidate_id, this.checkStatusChangeObj.applicationId)
                    .subscribe((resp) => {
                      console.log(resp);
                    });
                }
                if (this.checkStatusChangeObj.activityId == 600304) {
                  this.offerAcceptReject();
                }
                if (this.selectedActivity()) {
                  console.log('applicationIds', this.candidateApplicationIds);
                  const indentDeletionObject = {
                    activityId: this.activityService.lastActivityPerformed.activityid,
                    companyHiringTypeId: +localStorage.getItem('fresherCompHiringTypeId'),
                    applicationId: this.candidateApplicationIds[0],
                  };
                  this.activityService.indentdeletion(indentDeletionObject).subscribe(
                    (response) => {
                      console.log('indent unblock', response);

                      const data = {
                        msg: 'Saved Successfully',
                        isSuccess: true,
                      };
                      console.log('dataDisplayed', data);
                      this.activityService.openSnackBar(data, 'success-snack');
                    },
                    (_err) => {
                      const data = {
                        msg: 'Some error occurred',
                        isSuccess: false,
                      };
                      this.activityService.openSnackBar(data, 'danger-snack');
                    },
                  );
                }
                if (
                  this.checkStatusChangeObj.activityId == 500306 &&
                  localStorage.getItem('fresherCompHiringTypeId') === '1'
                ) {
                  const whatsAppDP = {
                    candidatId: this.candidateObj[0].candidateId,
                    applicationId: this.checkStatusChangeObj.applicationId,
                    activityId: 500306,
                    reasonId: Number(this.reasonId),
                    whatsappRemarks: 'whatsappHRpending',
                    context: 'form2_message_trigger',
                  };
                  this.activityService.whatsAppDP(whatsAppDP).subscribe((_res) => {
                    console.log('Whatsapp at DP');
                  });
                }
                if (this.ifCoupled) {
                  this.createdOnValue.emit(res.createdOn);
                }
                if (
                  this.checkStatusChangeObj.activityId == 500301 &&
                  (this.compHiringTypeID == 4 ||
                    this.compHiringTypeID == 1 ||
                    this.compHiringTypeID == 2 ||
                    this.compHiringTypeID == 6)
                ) {
                  const data = {
                    applicationIds: this.checkStatusChangeObj.applicationId,
                    hiringTypeId: this.companyHiringType,
                  };
                  this.activityService.pushResumefromIntapToIWP(data).subscribe((_res) => {
                    console.log('Resume at TBI');
                  });
                }
              }
              if (
                this.screenDesc == 'BPM' &&
                this.checkStatusChangeObj.activityId == 600301 &&
                this.compHiringTypeID == 4
              ) {
                this.notificationOfOffer();
              }

              //this.getActivity();
              if (this.isMapFile) {
                this.fileService.saveAttachmentMultiple(
                  this.checkStatusChangeObj.applicationId,
                  this.companyHiringType,
                  this.fileData,
                  this.deletedFile,
                  this.checkStatusChangeObj.activityId,
                );
              } else {
                this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
              }
              const data = {
                msg: res.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(data, 'success-snack');
              if (!this.ifCoupled) {
                this.refreshcandiates.emit('true');
              }
            }
          },
          (_err) => {
            const data = {
              msg: 'Some error occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );
    }
    //}
  }

  notificationOfOffer() {
    const pId = 60;
    // let compId = "4";
    const actId = 600204;
    const ccEmail = this.empEmail.split('@')[0] + '@infosys.com';
    this.templateObj[0].companyHiringTypeId = '4';
    this.templateObj[0].activityId = 600204;
    this.activityService.getTemplate(actId, pId).subscribe(
      (data1) => {
        if (data1 && data1.length > 0) {
          this.clauses = data1[0];
          // console.log("@@@@@@", this.clauses)

          //Replacing first name dynamically
          const candidate = {
            fname: this.resObj.fname,
          };
          const body = this.clauses.templateBody.replace(/\<\<(.*?)\>\>/g, function (match, token) {
            return candidate[token];
          });

          this.mailBody = body;
          const appId_ = [this.checkStatusChangeObj.applicationId];
          const postDataObj: ISaveCorrespondenceActivity = {
            applicationIds: appId_,
            processId: 60,
            activityId: 600204,
            comments: this.notes,
            clause_id: this.clauses.clauseid,
            mailerID: 1010,
            // "clausMasterList": null,
            cc: ccEmail,
            bcc: '',
            templateId: this.clauses.templateId,
            mobileRequest: false,
            eventId: null,
            templateSubject: this.clauses.templateSubject,
            templateBody: body,
          };
          if (postDataObj && postDataObj.applicationIds && postDataObj.activityId && postDataObj.processId) {
            this.activityService.saveCorrespondenceActivity(postDataObj).subscribe((_response_) => {
              const data = {
                msg: 'Saved Successfully',
                isSuccess: true,
              };
              this.activityService.openSnackBar(data, 'success-snack');
              if (this.compHiringTypeID == 4 && this.candidateDetail[0].sourceId == '42') {
                this.referEMP_mail();
              }
            });
          }
        } else {
          const data = {
            msg: 'No Template Present! Email Not Sent ',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        }
      },
      (_err) => {
        const data = {
          msg: 'Something Went Wrong. Email Not Sent',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );
  }

  editStatusChangeActivity(editObj: StatusChangeActivity) {
    console.log('inside edit');

    this.activityService.editStatusChangeActivity(editObj).subscribe(
      (res: any) => {
        console.log('response' + res);
        if (this.isMapFile) {
          this.fileService.saveAttachmentMultiple(
            this.checkStatusChangeObj.applicationId,
            this.companyHiringType,
            this.fileData,
            this.deletedFile,
            this.checkStatusChangeObj.activityId,
          );
        } else {
          this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
        }
        // this.getActivity();
        if (this.ifCoupled) {
          this.createdOnValue.emit(res.createdOn);
        }

        const data = {
          msg: 'Data Updated Successfully !!! ',
          isSuccess: true,
        };
        this.activityService.openSnackBar(data, 'success-snack');
        // this.activityService.openSnackBar('Data Updated Successfully !!! ', 'success-snack');
      },
      (err) => {
        const data = {
          msg: err,
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );
    // this.dialogRef.close();
    if (!this.ifCoupled) {
      this.dialogRef.close();
    }
  }

  getActivity(obj: CheckstatusChangeObj) {
    // obj.createdOn
    console.log(obj.createdOn);
    console.log('indide get activity function in component');
    // this.ids = this.activityService.getDataIds();
    this.activityService
      .getStatusChangeActivity(obj.applicationId, obj.activityId, obj.processId, obj.createdOn)
      .subscribe((response: StatusChangeActivity) => {
        this.checkStatusChangeObj.statusChangeActivity = response;
        if (this.ifCoupled) {
          this.createdOnValue1.emit(response.createdOn);
        }

        console.log('response ------->', response, typeof response, Array.isArray(response));
        console.log('modifiedOn --->', response.modifiedOn, typeof response.modifiedOn);
        this.dataInitialization(response);
      });
  }

  dataInitialization(statusChangeactivityObj: StatusChangeActivity) {
    if (statusChangeactivityObj == null) {
      console.log(statusChangeactivityObj);

      console.log('if');

      this.notes = '';
      this.reasonid = 0;
      this.isDeleteDisable = true;
    } else {
      console.log('else');
      if (this.checkStatusChangeObj.activityId == 500317) {
        this.hrChecklistNotes = statusChangeactivityObj.notes;
      }

      this.notes = statusChangeactivityObj.notes;
      // time
      this.timeModifiedOn = statusChangeactivityObj.modifiedOn;

      this.reasonId = statusChangeactivityObj.reason.reasonId.toString();
      this.unavailableDate = new Date(statusChangeactivityObj?.unavailableDate);
      this.isDeleteDisable = false;
      // this.hrChecklistNotes = statusChangeactivityObj.notes;
    }
  }

  delete() {}

  receiveFileOutput(filedata) {
    let disableSFO = true;
    console.log('recieve file data', filedata);
    this.fileData = filedata['fileMerge1'];
    this.deletedFile = filedata['deletedFile1'];

    //check for attachment and enable/disable send button for offer accept by recruiter after offer rejected
    let hasAttachment = false;
    let hasAttachment288 = false;
    let hasAttachment289 = false;
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file: any) => {
        if (file.attachmentId == 288) {
          hasAttachment288 = true;
        }
        if (file.attachmentId == 289) {
          hasAttachment289 = true;
        }
      });
    }
    if (this.offerRejectCheck && hasAttachment288) {
      hasAttachment = true;
    } else if (this.offerInvalidRejectCheck && hasAttachment289 && hasAttachment288) {
      hasAttachment = true;
    }
    if (hasAttachment && (this.offerRejectCheck || this.offerInvalidRejectCheck)) {
      this.disableOfferSendBtn = false;
    } else if (!hasAttachment && (this.offerRejectCheck || this.offerInvalidRejectCheck)) {
      this.disableOfferSendBtn = true;
    } else {
      this.disableOfferSendBtn = false;
    }

    if (
      (this.checkStatusChangeObj.activityId == 600301 && ['1', '6', '4', '9'].includes(this.companyHiringType)) ||
      (this.checkStatusChangeObj.activityId == 500308 && this.companyHiringType == '1')
    ) {
      const te = this.fileData.find((f) => f && f.attachmentId == 120);
      console.log(te);
      if (te && this.flagData == 'N') {
        disableSFO = false;
      } else if (this.flagData == 'Y') {
        disableSFO = false;
      } else if (this.flagData == 'YES') {
        disableSFO = false;
      } else if (['Q', 'CBI', 'NCBI', 'NOBA', 'M', 'T', 'SKIPSFO'].includes(this.flagData)) {
        disableSFO = this.hasRequiredFile();
      }
      this.disableSFO = disableSFO;
    } else if (this.checkStatusChangeObj.activityId == 500317 && this.companyHiringType == 1) {
      // let skipHRFile = this.fileData.find(f => f && f.attachmentId == 279);
      // if(skipHRFile){
      //   this.skipHRFileExist = true;
      // }

      const errorCode1 = this.fileData.find((f) => f && f.attachmentId == 117);
      const errorCode2 = this.fileData.find((f) => f && f.attachmentId == 115);
      if (this.errorCode == 0) {
        this.disableSubmit = false;
      } else if (this.errorCode == 1) {
        this.disableSubmit = !errorCode1;
      } else if (this.errorCode == 2) {
        this.disableSubmit = !(errorCode1 && errorCode2);
      }
    }
  }

  saveAttachment(genericId, companyHiringTypeId) {
    console.log('save attchmnt');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (res) => {
            console.log('file delete res', res);
          },
          (err) => {
            console.log('file delete error', err);
          },
        );
      });
    }
    const activityId: any = this.checkStatusChangeObj.activityId;
    const fd = new FormData();
    fd.append('objectId', genericId);
    fd.append('objectType', 'AP');
    fd.append('attachmentId', '2');
    fd.append('companyHiringTypeId', companyHiringTypeId);
    fd.append('activityId', activityId);
    console.log(this.fileData);
    if (this.fileData && this.fileData.length > 0) {
      console.log('inside loop');
      this.fileData.forEach((file) => {
        fd.append('file[' + file.name + ']', file);
      });
      this.fileService.upload(fd).subscribe(
        (res) => {
          console.log(res);
        },
        (_err) => {
          const data = {
            msg: 'Some error Occurred while saving attachment',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        },
      );
    }
  }

  statusChangeForRecall(obj) {
    this.activityService.saveStatusChangeActivity(obj).subscribe(
      (res: any) => {
        console.log(res);
        console.log('calling get statuschange activity check updated notes');
        if (res.error && res.error.toLowerCase() === 'failure') {
          const data = {
            msg: res.message,
            isSuccess: false,
          };

          console.log(data);
          this.activityService.openSnackBar(data, 'danger-snack');
        } else {
          this.value = true;
          // this.refreshcandiates.emit("true");
          //this.getActivity();
          if (this.isMapFile) {
            this.fileService.saveAttachmentMultiple(
              this.checkStatusChangeObj.applicationId,
              this.companyHiringType,
              this.fileData,
              this.deletedFile,
              this.checkStatusChangeObj.activityId,
            );
          } else {
            this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
          }
          this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
          const data = {
            msg: res.message,
            isSuccess: true,
          };
          this.activityService.openSnackBar(data, 'success-snack');
        }
      },
      (_err) => {
        const data = {
          msg: 'Some error occurred',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );
  }
  offerAcceptReject() {
    if (this.screenDesc == 'Lateral') {
      if (this.resObj.indentId != null) {
        this.activityService
          .unblockIndent(this.candidateApplicationIds[0], this.unBlockIndentObj)
          .subscribe((_indRes) => {
            if (this.launchPad.candidate[0].offerStatus != 'Offer Rejected') {
              this.activityService.indentBlock(this.indentObject).subscribe((_dataFetch) => {
                console.log('INDENT ACTION EXECTUTEDD SUCCESSFULLY');
              });
            }
          });
      }
      this.activityService
        .unBlockBudget(this.candidateApplicationIds[0], this.checkStatusChangeObj.activityId)
        .subscribe((_unblockD) => {
          if (this.typeFlag === 'A') {
            this.activityService
              .blockBudget(this.candidateApplicationIds[0], this.checkStatusChangeObj.activityId)
              .subscribe((responseBB) => {
                console.log('blockbudget', responseBB);
              });
          }
        });
    }
    if (this.screenDesc == 'BPM') {
      if (this.typeFlag == 'A') {
        if (this.resObj.indentId != null) {
          this.activityService.blockIndentBpm(this.blockIndentBpo).subscribe(
            (_dataFetch) => {},
            (err) => {
              console.log(err);
            },
          );
        }
      }
      if (this.typeFlag == 'R') {
        if (localStorage.getItem('role') === 'Recruiter' && localStorage.getItem('fresherCompHiringTypeId') === '6') {
          const indentObj = {
            activityId: this.activityService.lastActivityPerformed.activityid,
            companyHiringTypeId: +localStorage.getItem('fresherCompHiringTypeId'),
            applicationId: this.candidateApplicationIds[0],
          };
          this.activityService.unblockChinaIndent(indentObj).subscribe({
            next: (data) => {
              console.log('China Indent unblock', data);
            },
            error: (err) => {
              console.log('China indent unblock issue ', err);
            },
          });
        }
        if (localStorage.getItem('role') === 'Recruiter' && localStorage.getItem('fresherCompHiringTypeId') === '4') {
          const indentDeletionObject = {
            activityId: this.activityService.lastActivityPerformed.activityid,
            companyHiringTypeId: +localStorage.getItem('fresherCompHiringTypeId'),
            applicationId: this.candidateApplicationIds[0],
          };
          this.activityService.indentdeletion(indentDeletionObject).subscribe((deletionResponse) => {
            console.log('indent deletion', deletionResponse);
          });
        } else {
          if (this.resObj.indentId != null) {
            this.activityService.openIndentBpm(this.openIndentBpo).subscribe(
              (_dataF) => {},
              (err) => {
                console.log(err);
              },
            );
          }
        }
      }
    }
    if (this.checkStatusChangeObj.activityId != 600305) {
      this.activityService.updateLaunchPad(this.launchPad).subscribe((responseLP) => {
        console.log('launchpad', responseLP);
      });
    }
  }

  createPdf() {
    // this.createCandidateData();
    const doc = new jsPDF('p', 'pt', 'a4');
    doc.setFont('times');
    doc.setFontSize(10);
    this.setLogo(doc);
    const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;

    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const _footerHeight = 200;
    const footerText = 'Company Confidential - This communication is confidential between you and Infosys Limited ';
    let yPos = 110;
    const xPos = 35;
    // this.setFooterAddress(doc); //  adding footer first to get sez address

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const releaseDate = new Date(this.candidateOfferDetail.released_date);
    const formatedReleaseDate =
      months[releaseDate.getMonth()] + ' ' + releaseDate.getDate() + ', ' + releaseDate.getFullYear();

    const joiningDate = new Date(this.candidateOfferDetail.joining_date);
    const _formatedjoiningDate =
      months[joiningDate.getMonth()] + ' ' + joiningDate.getDate() + ', ' + joiningDate.getFullYear();

    // var dojAdd = [this.mailBody
    // ]

    const candname =
      this.candidateObj[0].firstName.toLowerCase().charAt(0).toUpperCase() +
      this.candidateObj[0].firstName.toLowerCase().slice(1);

    this.reasonvalue = this.rejectionReasons.filter((ele) => {
      return ele.indexOf(this.reasonId.toString()) != -1;
    })[0][1];

    const dojAdd = [
      'Dear ' + candname + ',',
      'This is with reference to our Offer Of Employment to you dated ' +
        formatedReleaseDate +
        '(Ref. No. HRD/COV/' +
        this.candidateObj[0].candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'We note that the record details provided by you in the application form are not accurate. This constitutes ' +
        this.reasonvalue +
        '.',
      'Hence, we regret that Infosys will not be able to consider your application for employment.',
      'As a result, the above-mentioned letter stands withdrawn and we shall no longer pursue your application with Infosys.',
      'Yours Sincerely,',
    ];

    // var locationAdd = [this.mailBody
    // ]

    // var dojAndLocation = [this.mailBody
    // ]
    const pdfTxt = dojAdd;
    this.attachmentName = 'OfferRevoke.pdf';
    // if (this.jl == "4") {
    //   pdfTxt = locationAdd;
    //   this.attachmentName = "LocationAddendum.pdf"
    // }
    // if (this.jl == "5") {
    //   pdfTxt = dojAndLocation;
    //   this.attachmentName = "DOJAndLocationAddendum.pdf"
    // }
    doc.text('HRD/' + this.candidateObj[0].candidateId + '/' + this.getCurrentFinancialYear(), xPos, yPos);
    const todayDate = new Date();
    const dateInFormat = months[todayDate.getMonth()] + ' ' + todayDate.getDate() + ', ' + todayDate.getFullYear();
    doc.text(dateInFormat, 522 - doc.getTextWidth(dateInFormat), yPos);
    yPos += lineHeight * 2;
    let title = 'Mr.';
    if (this.candidateObj[0].gender == 'F' || this.candidateObj[0].gender == '2') {
      title = 'Ms.';
    }
    let candidateName = this.candidateObj[0].candidateName;
    if (candidateName) {
      candidateName = this.titleCase(candidateName);
    }
    const fullName = title + ' ' + candidateName;
    doc.text(fullName, xPos, yPos);
    yPos += lineHeight;
    const address = this.candAdress;
    doc.text(address.primaryAddress, xPos, yPos);
    yPos += lineHeight;
    doc.text(address.cityName, xPos, yPos);
    yPos += lineHeight;
    doc.text(address.stateName, xPos, yPos);
    yPos += lineHeight;
    doc.text(address.countryName, xPos, yPos);
    yPos += lineHeight * 2;
    const phoneNum = this.candidateObj[0].primaryContactNo;
    // phoneNum =  phoneNum.substr(phoneNum.length - 10)
    doc.text('Ph: ' + phoneNum, xPos, yPos);
    yPos += lineHeight * 2;
    for (let i = 0; i < pdfTxt.length; i++) {
      // pdfTxt[i] = this.displayText(pdfTxt[i]);
      const splt = doc.splitTextToSize(pdfTxt[i], 480);
      const lines1 = splt.length; // splitted text is a string array
      const blockHeight = lines1 * lineHeight;
      doc.text(splt, xPos, yPos, { align: 'justify', maxWidth: 500 });
      yPos = yPos + blockHeight + lineHeight;
    }
    // commenting the Sign image as per new format
    const signImg =
      'data:image/png;base64,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';
    doc.addImage(signImg, 'PNG', 35, yPos, 80, 40);
    yPos = yPos + lineHeight + 50;
    yPos += lineHeight;
    doc.setFont('times', 'bold');
    doc.setFontSize(12);
    doc.text('Varadharaj Venkataraman', xPos, yPos);
    yPos += lineHeight;
    doc.text('SVP - Head - Talent Acquisition - Infosys Limited', xPos, yPos);
    doc.setFont('times', 'normal');
    doc.setFontSize(10);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('I have read, accept and agree to the terms and conditions as set forth in this letter.', xPos, yPos);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('Date: ___________________________, 20____', xPos, yPos);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('_______________________________________ ', xPos, yPos);
    yPos += lineHeight;
    doc.text('Sign your name', xPos, yPos);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('____________________ ___________________ ', xPos, yPos);
    yPos += lineHeight;
    doc.text('Print your name            Location', xPos, yPos);
    yPos += lineHeight;

    let footerPos = 20;
    doc.text('Page 1 of  1', pageWidth / 2, pageHeight - footerPos, { align: 'center' });
    footerPos += lineHeight;
    doc.setFont('times', 'italic');
    doc.text(footerText, pageWidth / 2, pageHeight - footerPos, { align: 'center' });
    doc.setFont('times', 'normal');
    this.addressString = '';
    // doc.save('add.pdf');
    return doc;
  }

  setLogo(doc: jsPDF) {
    const base64_source =
      'data:image/png;base64,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';
    doc.addImage(base64_source, 'PNG', 450, 20, 100, 50);

    // doc.save('offer revoke');
  }

  dateChange(a) {
    if (a.value === this.chkDoj) {
      this.changedDoj = false;
    } else {
      this.changedDoj = true;
    }
    this.chkDoj = this.doj;
    // this.enableButton()
  }

  locationChange(loc) {
    if (loc.option.value === this.chkLoc) {
      this.changedLoc = false;
    } else {
      this.changedLoc = true;
    }
    // this.locationValidation(loc.option.value)
  }

  createMailerObj() {
    this.templateObj[0].jl = 5;
    this.templateObj[0].companyHiringTypeId = this.companyHiringType;
    this.templateObj[0].activityId = 600307;
    this.activityService.fetchTemplate(this.templateObj).subscribe(
      (data1) => {
        this.textArray = [];
        const arr: any = data1;

        const jsonArr = JSON.parse(arr);
        this.textArray = jsonArr[0].clauses[0].texts;
        this.templateRecieved = true;
        this.mailSubject = jsonArr[0].templateDescription;

        console.log(this.textArray, 'textarray');
        this.activityService.getCandidateOfferUpdate(this.candidateApplicationIds[0]).subscribe((dataFetched) => {
          const candidate: any = dataFetched;
          const date = new DatePipe('en-US').transform(candidate.joining_date, 'dd-MMM-yyyy');
          const joinDate = new DatePipe('en-US').transform(candidate.released_date, 'dd-MMM-yyyy');

          //test
          const rndT = this.resObj.joining_time?.slice(0, -3);
          let date1;
          const amArray = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
          const loc1 = includes(amArray, rndT);
          if (loc1 == true) {
            date1 = this.resObj.joining_time + ' AM';
          } else {
            date1 = this.resObj.joining_time + ' PM';
          }

          //test

          const timeObj = {
            time: date1,
          };
          // timeObj.time = new DatePipe('en-US').transform(candidate.joining_date, 'mediumTime')
          Object.assign(candidate, timeObj);

          if (this.establishment?.includes('SEZ')) {
            candidate.establishment_type = 'SEZ';
          } else {
            candidate.establishment_type = '';
          }
          candidate.joining_date = date;
          candidate.year = this.getCurrentFinancialYear();
          candidate.released_date = joinDate;
          candidate.reason = this.reasonvalue;
          candidate.fname =
            candidate.fname.toLowerCase().charAt(0).toUpperCase() + candidate.fname.toLowerCase().slice(1);
          this.candidateOfferDetail = candidate;
          const result = this.textArray[0].text.replace(/\$\{(.*?)\}/g, function (match, token) {
            return candidate[token];
          });

          this.mailBody = result;
          const senderEmail = 'offers@infosys.com';
          const addendum = this.createPdf().output('datauristring');
          const attachmentName = this.attachmentName;

          const ccEmail = this.empEmail.split('@')[0] + '@infosys.com';

          const unblockdetails: UnblockModel = {
            appCode: 'InTap',
            candidateID: this.resObj.candidate_id,
            dateofJoining: this.resObj.joining_date,
            empNo: null,
            empSourceCode: 'InTap',
            indentID: this.resObj.indentId,
            lastModifiedBy: this.resObj.lastModifiedBy,
            stageCode: 'REOPEN',
          };

          const date2 = new Date(this.resObj.joining_date_time);
          const offset = date2.getTimezoneOffset();
          if (offset < 0) {
            date2.setHours(12, 0, 0);
          }

          const launpadDetails: LaunchpadModel = {
            candidateId: this.resObj.candidate_id,
            doj: date2,
            dateOfConfirmation: null,
            offerStatus: 'Offer Revoked',
            posLoc: this.resObj.location,
            unit: this.resObj.puCode,
            activityId: this.checkStatusChangeObj.activityId,
          };
          console.log(this.canEmail, 'candmail');

          // "to": this.canEmail,

          const mailerDetails: MailerModel = {
            to: this.canEmail,
            from: senderEmail,
            subject: this.mailSubject,
            body: this.mailBody,
            ccArray: [ccEmail],
            bccArray: [],
            files: {
              [attachmentName]: addendum.split(',')[1],
            },
          };

          const saveRevokeObj: OfferRevokeDetails = {
            appId: this.checkStatusChangeObj.applicationId,
            actId: this.checkStatusChangeObj.activityId,
            unblockmodel: unblockdetails,
            launchpad: launpadDetails,
            mailerModel: mailerDetails,
            processId: this.checkStatusChangeObj.processId,
            reasonId: this.reasonId,
            statusId: this.checkStatusChangeObj.statusId,
          };
          this.ngxLoader.start();
          this.activityService.saveUpdateRevokeWrapper(saveRevokeObj).subscribe(
            (res) => {
              console.log('response', res, saveRevokeObj);
              const datasuccess = {
                msg: res,
                isSuccess: true,
              };
              this.ngxLoader.stop();
              this.activityService.openSnackBar(datasuccess, 'success-snack');
            },
            (err) => {
              const dataerror = {
                msg: err.error,
                isSuccess: false,
              };
              this.ngxLoader.stop();
              this.activityService.openSnackBar(dataerror, 'danger-snack');
            },
          );

          // return result;
        });
      },
      (_err) => {
        // this.__warningER.next('Some Error Occured')
        alert('Unable to fetch Template');
        // this.templateRecieved = false
      },
    );
  }

  getCurrentFinancialYear() {
    let fiscalyear = '';
    const today = new Date();
    if (today.getMonth() + 1 <= 3) {
      fiscalyear = (today.getFullYear() - 1 + '').slice(-2) + '-' + (today.getFullYear() + '').slice(-2);
    } else {
      fiscalyear = (today.getFullYear() + '').slice(-2) + '-' + (today.getFullYear() + 1 + '').slice(-2);
    }
    return fiscalyear;
  }

  titleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }
  reasonIdChange(reason) {
    if (this.companyHiringType == 4) {
      this.remarksMandatory = true;
      this.notes = '';
      if (this.reasonId == '551') {
        this.remarksMandatory = false;
      }
      if (this.reasonId == '537') {
        this.notes = 'Artifact needs to be added';
      }
      if (Number(this.checkStatusChangeObj.activityId) == 600311) {
        this.checkFaceValidationSendButton();
      }

      if(Number(this.checkStatusChangeObj.activityId) == 200304){
        this.reasonlist.emit(reason);
      }

    }
    if (
      (this.checkStatusChangeObj.activityId == 500305 || this.checkStatusChangeObj.activityId == 500307) &&
      this.compHiringTypeID == 1
    ) {
      this.displayReason.emit(true);
      this.reasonlist.emit(reason);
      this.activityId.emit(this.checkStatusChangeObj.activityId);
    }
  }

  isReasonHidden(reason): boolean {
    return !(this.ifCoupled && this.companyHiringType == '4' && 
     Number(this.checkStatusChangeObj?.activityId) == 200304 && 
     this.excludedReasonIds.indexOf(Number(reason?.[0])) > -1);
  }

  CheckEhc() {
    console.log(this.checkStatusChangeObj, this.checkStatusChangeObj.activityId, 'ehc first condition');
    console.log(this.resObj, 'ehc UAN');

    if (this.checkStatusChangeObj && this.checkStatusChangeObj.activityId == 600301) {
      if (!this.resObj.uanNumber && this.resObj.uanReason) {
        console.log(this.resObj, 'ehc inside reason case');
        let id = null;
        if (this.fileData) {
          id = this.fileData.find((f) => f && f.attachmentId == 126);
        }
        let dialog;
        let dialogMsg;
        if (id && this.companyHiringType == 1) {
          const uanReason = this.resObj.uanReason;
          const cutIndex = uanReason.indexOf('done.') + 'done.'.length;
          const newUanReason = `${uanReason.substring(0, cutIndex)}`;
          dialogMsg = new ConfirmDialogModel('', newUanReason);
          dialog = this.confirmDialog.open(ConfirmPopupComponent, {
            maxWidth: '400px',
            data: dialogMsg,
            disableClose: true,
          });
          dialog.afterClosed().subscribe((popResult) => {
            if (popResult) {
              console.log(popResult);
              this.send1();
            } else {
              const data = {
                msg: "Please upload the exception attachment under 'UAN Exception' category",
                isSuccess: false,
              };
              this.activityService.openSnackBar(data, 'danger-snack');
            }
          });
        } else {
          const uanReason = this.resObj.uanReason;
          const cutIndex = uanReason.indexOf('done.') + 'done.'.length;
          const newUanReason = `${uanReason.substring(0, cutIndex)}`;
          dialogMsg = new ConfirmDialogModel(
            '',
            newUanReason +
              ' Please get exceptional approval from the Background verification team to proceed with Selected for Offer activity.',
          );
          dialog = this.confirmDialog.open(ConfirmPopupComponent, {
            maxWidth: '400px',
            data: dialogMsg,
            disableClose: true,
          });
          dialog.afterClosed().subscribe((_popResult) => {
            const data = {
              msg: "Please upload the exception attachment under 'UAN Exception' category",
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          });
        }
      } else {
        console.log(this.resObj, 'ehc inside else case');
        this.send1();
      }
    }
  }
  referEMP_mail() {
    this.activityService.sendRefMail(this.candidateApplicationIds[0]).subscribe((res) => {
      console.log(res);
    });
  }

  setHRans(si, qi, event) {
    this.hrChecklist[si].question[qi]['selectedAns'] = event.value;
  }

  saveHRChecklist() {
    // if (this.isSkipHRCheck) {
    //   //call save app status change api
    //   if (this.skipHRFileExist) {
    //     this.reasonId = 20;
    //     this.send1();
    //   } else {
    //     let dialog;
    //     let dialogMsg;
    //     dialogMsg = new ConfirmDialogModel('WARNING!', 'Please upload approval under Skip HR category and submit.');
    //     dialog = this.confirmDialog.open(ConfirmPopupComponent, { maxWidth: "450px", data: dialogMsg, disableClose: true });
    //   }
    //   return;
    // }
    if (!this.hrApplicationForm || !this.hrExpEHC) {
      const data = {
        msg: 'Please confirm that you have validated all details in View profile page',
        isSuccess: false,
      };
      this.activityService.openSnackBar(data, 'danger-snack');
      return;
    }
    const reqQues = [];
    if (this.hrApplicationForm && this.hrExpEHC && this.hrChecklistNotes) {
      let quesError = true;
      for (const hrc in this.hrChecklist) {
        quesError = true;
        console.log(hrc, typeof hrc);
        for (const hrQ of this.hrChecklist[hrc].question) {
          if (hrQ.selectedAns && hrQ.selectedAns.toLowerCase() == 'yes') {
            reqQues.push({ question: hrQ.questionId, answer: hrQ.selectedAns });
          } else {
            quesError = false;
            this.expandedEvent = this.hrChecklist[hrc].sectionName;
            this.selectedIndexQ = parseInt(hrc);
            break;
          }
        }
        if (!quesError) {
          break;
        }
      }
      if (!quesError) {
        const data1 = {
          msg: "Please make sure all the values in Questionnaire are 'Yes'",
          isSuccess: false,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
      } else {
        const saveHRchecklist = {
          applicationId: this.candidateObj[0].applicationId,
          model: reqQues,
          notes: this.hrChecklistNotes,
          offerType: this.selectedOfferType(),
        };
        const dialogMsg = new ConfirmDialogModel(
          'WARNING!',
          '    No further edit is allowed for Work experience considered(Yes/NO), version 2 application form and HR checklist.',
        );
        const dialog = this.confirmDialog.open(ConfirmDialogComponent, {
          maxWidth: '450px',
          data: dialogMsg,
          disableClose: true,
        });
        dialog.afterClosed().subscribe((popResult) => {
          if (popResult) {
            this.activityService.saveHRchecklist(saveHRchecklist).subscribe((res) => {
              console.log(res);
              if (res.hrChecklistRsponse == 'Success') {
                // this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
                if (this.isMapFile) {
                  this.fileService.saveAttachmentMultiple(
                    this.checkStatusChangeObj.applicationId,
                    this.companyHiringType,
                    this.fileData,
                    this.deletedFile,
                    this.checkStatusChangeObj.activityId,
                  );
                } else {
                  this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
                }
                const data = {
                  msg: res.msg,
                  isSuccess: true,
                };
                this.activityService.openSnackBar(data, 'success-snack');
                if (!this.ifCoupled) {
                  this.refreshcandiates.emit('true');
                }
              } else {
                const data = {
                  msg: res.msg,
                  isSuccess: false,
                };
                this.activityService.openSnackBar(data, 'danger-snack');
              }
            });
          }
        });
      }
    } else {
      const data = {
        msg: 'Please provide mandatory remarks.',
        isSuccess: false,
      };
      this.activityService.openSnackBar(data, 'danger-snack');
    }
  }
  callCheckBpm() {
    this.ngxLoader.start();
    this.activityService.checkBpm(this.candidateObj[0].applicationId).subscribe((cBpmData) => {
      console.log(cBpmData);
      this.ngxLoader.stop();
      if (cBpmData != 'Success') {
        this.disableSFO = true;
        const data1 = {
          msg: cBpmData,
          isSuccess: false,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
      } else {
        this.sfoMssg = null;
        this.ngxLoader.start();
        this.activityService.getFlag(this.candidateObj[0].applicationId).subscribe({
          next: (Data) => {
            this.ngxLoader.stop();
            if (Data.flag == 'N') {
              this.flagData = Data.flag;
              this.disableSFO = true;
              this.sfoMssg = Data.message;
              this.openModalSfo();
            } else if (Data.flag == 'Y') {
              this.flagData = Data.flag;
              this.disableSFO = false;
            } else if (Data.flag == 'R') {
              this.flagData = Data.flag;
              this.disableSFO = true;
              const data = {
                msg: Data.message,
                isSuccess: false,
              };
              this.activityService.openSnackBar(data, 'danger-snack');
            } else if (Data.flag == 'CBI' || Data.flag == 'NCBI') {
              this.disableSFO = true;
              this.flagData = Data.flag;
              this.sfoMssg = Data.message;
              console.log(this.sfoMssg);
              this.openModalSfo();
            }
          },
          error: () => {
            this.flagData = 'R';
            const data = {
              msg: 'Panelist validation is not working, please try again !!',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
          complete: () => {
            this.ngxLoader.stop();
          },
        });
      }
    });
  }

  openViewProfile() {
    const viewProfileData = {
      screenName: '',
      candidateId: this.candidateId ? this.candidateId : this.candidateObj[0].candidateId,
      applicationId: this.checkStatusChangeObj.applicationId,
    };
    const roleCodeCheck = localStorage.getItem('role');
    if (roleCodeCheck == 'Scheduler') {
      viewProfileData.screenName = 'Scheduler';
    } else if (roleCodeCheck == 'Recruiter') {
      viewProfileData.screenName = 'Recruiter';
    } else if (roleCodeCheck == 'Offer DEO') {
      viewProfileData.screenName = 'Offer_ViewProfile';
    } else {
      viewProfileData.screenName = 'Scheduler';
    }
    const dialogRef = this.confirmDialog.open(ViewProfileComponent, {
      width: '1500px',
      height: '650px',
      data: viewProfileData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      if (result) {
        //for success
        this.activityService.openSnackBar({ msg: 'Saved Successfully', isSuccess: true }, 'success-snack');
      }
    });
  }

  get isInterviewDateRequired(): boolean {
    return (
      ['40', '50'].includes(this.checkStatusChangeObj?.processId.toString()) &&
      ['400405', '400406'].includes(this.checkStatusChangeObj?.activityId.toString()) &&
      this.companyHiringType == 1
    );
  }

  hasRequiredFile(): boolean {
    const flagConditionArr = {
      Q: [143],
      CBI: [145],
      NCBI: [145, 120],
      NOBA: [270],
      M: [272],
      T: [271],
      SKIPSFO: [276],
    };
    return this.fileData?.some((f) => flagConditionArr[this.flagData]?.includes(f.attachmentId)) ? false : true;
  }
}
